import React from 'react';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Image from 'react-bootstrap/Image';

import Logo from '../images/SunWestLogo.png'

export default function Header() {
    return (
        <Container fluid>
            <Row>
                <Col md={4} lg={2} className="p-3">
                    <Image src={Logo} fluid alt="Sun West Mortgage Logo" />
                </Col>
            </Row>
            
        </Container>
    )
}
